import React, { useEffect, useRef, useState } from "react";

const STATS = [
  { num: "25", label: "Years working and building enterprise apps", accent: "#6B8EF0" },
  { num: "100%", label: "Satisfaction across cohorts", accent: "#00D4AD" },
  { num: "10", label: "Products in the ecosystem", accent: "#D4891A" },
  { num: "2025", label: "Year MERA was founded", accent: "#0A0A0A" },
];

const Counter = ({ value }) => {
  return <span className="font-serif-display">{value}</span>;
};

export const Stats = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.2 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      data-testid="stats-section"
      className="px-6 md:px-10 py-24 md:py-28 bg-[#0A0A0A] text-[#F7F7F6]"
    >
      <div className="grid grid-cols-12 gap-6 mb-12">
        <div className="col-span-12 md:col-span-3">
          <div className="font-mono-label text-[11px] text-white/50">§ 04 · By the numbers</div>
        </div>
        <div className="col-span-12 md:col-span-9">
          <h2 className="font-serif-display text-[40px] md:text-[60px] leading-[1.05] tracking-tight">
            A quiet record, <span className="italic-accent text-white/80">measured.</span>
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border-t border-b border-white/10">
        {STATS.map((s, idx) => (
          <div
            key={idx}
            data-testid={`stat-${idx}`}
            className={`bg-[#0A0A0A] p-8 md:p-10 min-h-[200px] flex flex-col justify-between transition-all duration-700 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
            style={{ transitionDelay: `${idx * 120}ms` }}
          >
            <div
              className="text-[44px] md:text-[64px] leading-none tracking-tight"
              style={{ color: s.accent === "#0A0A0A" ? "#F7F7F6" : s.accent }}
            >
              <Counter value={s.num} />
            </div>
            <div className="font-mono-label text-[10px] text-white/55 mt-6">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
